export default __webpack_public_path__ + "static/media/Theme14.b1a737cb.png";